import {Action} from '@ngrx/store';
import {DressCode} from '../../../models/dress-code';

export class GetDressCodeSuccessAction implements Action {
  public static readonly type = 'GetDressCodesSuccessAction';

  constructor(public dressCode: DressCode) {
  }

  public type = GetDressCodeSuccessAction.type;
}
